// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".opacity-choice__btn[data-v-02bbfb23]{display:flex;flex-direction:column;align-items:center;grid-gap:4px;gap:4px;height:28px!important;font-size:10px;line-height:1}.opacity-choice__slider[data-v-02bbfb23]{width:120px;padding:0 10px;border-radius:5px;border:1px solid rgba(60,60,60,.26);box-shadow:0 3px 6px 0 rgba(0,0,0,.15);background:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
